__turbopack_context__.v({
  "code": "CUv8JG_code",
  "codeBlock": "CUv8JG_codeBlock",
  "container": "CUv8JG_container",
});
